module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Italic-b721fdeaecf6bcc259b8a5abf298080d.svg";